import { render } from "./BuildCard.vue?vue&type=template&id=62d18f0e&ts=true"
import script from "./BuildCard.vue?vue&type=script&lang=ts"
export * from "./BuildCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__